import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import React, { lazy, Suspense } from 'react';
import { CartProvider } from '../components/Cartcomponet';
import PageLoader from '../components/PageLoader';
import { LEGACY_STORE_REDIRECTS, buildStorePath } from '../config/storeCatalog';

const Homepage = lazy(() => import('../pages/Homepage'));
const Contact = lazy(() => import('../pages/Contact'));
const Aboutus = lazy(() => import('../pages/Aboutus'));
const Store = lazy(() => import('../pages/Store'));
const Viewproduct = lazy(() => import('../pages/Viewproduct'));
const Cart = lazy(() => import('../pages/Cart'));
const Payment = lazy(() => import('../pages/Payment'));
const Ordersuccessful = lazy(() => import('../pages/Ordersuccessful'));

const LegacyStoreRedirect = () => {
  const location = useLocation();
  const mapping = LEGACY_STORE_REDIRECTS[location.pathname];
  if (!mapping) return <Navigate to="/store" replace />;
  return <Navigate to={buildStorePath(mapping)} replace />;
};

const Routesfile = () => {
  return (
    <div>
      <Navbar />
      <Suspense fallback={<PageLoader />}>
        <CartProvider>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/store" element={<Store />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Aboutus" element={<Aboutus />} />
            <Route path="/Viewproduct/:product_id" element={<Viewproduct />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/Payment" element={<Payment />} />
            <Route path="/Ordersuccessful" element={<Ordersuccessful />} />

            {/* Legacy category routes → Store */}
            {Object.keys(LEGACY_STORE_REDIRECTS).map((path) => (
              <Route
                key={path}
                path={path}
                element={<LegacyStoreRedirect />}
              />
            ))}
          </Routes>
          <Footer />
        </CartProvider>
      </Suspense>
    </div>
  );
};

export default Routesfile;
